import AjaxService from 'services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchConnectedCalendars = () => {
    return AjaxService({
        method: 'get',
        url: 'users/me/calendars'
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const addConnectedCalendars = calendars => {
    return AjaxService({
        method: 'post',
        url: 'users/me/calendars',
        data: {
            calendars
        }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const removeConnectedCalendars = calendars => {
    return AjaxService({
        method: 'delete',
        url: 'users/me/calendars',
        data: {
            calendars
        }
    })
        .then(response => response.data)
        .catch(handleServerError);
}
